//船只认证申请定义

import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 状态
 */
class State extends UltMeta {
    PENDING_APPROVAL = new Meta(1, "待审核");
    REJECTED = new Meta(2, "已驳回");
    PASSED = new Meta(3, "已通过");
}

export const STATE = new State();
